import { useEffect, useRef } from 'react';
import { createRippleEffectRelative, getScreenName } from '../../Utils/helper';
import { SelectFavDiaper } from './TopBannerwithtext/styled';
import { isDesktopUser } from '../../Utils/ProductUtils';
import { fireEvent } from '../../Utils/fireEvent';

export default function SelectYourDiaperCTA(props) {
  const {
    particularRef,
    selectDiaperRef,
    text,
    setShowAnimation,
    setShowHeader,
    setShowTop,
    setShowLockedProductsAnimation,
    productCount,
    isForNewCdPage,
    lockedProductSectionRef,
    nonFreebieProductCount,
  } = props;
  const selectDiaperRipple = useRef();
  const choosenRef = selectDiaperRef || selectDiaperRipple;
  const particularElementHandler = () => {
    fireEvent({
      category: 'clicked_cta',
      screen_name: getScreenName(),
      cta: text,
      parent: 'Jump',
      page_url: window.location.href,
      section_name: text,
    });
    particularRef.current?.scrollIntoView({
      behavior: 'smooth',
    });

    if (isForNewCdPage) {
      if (productCount >= 2 && nonFreebieProductCount >= 2) {
        const element = lockedProductSectionRef.current;
        const offset = 70;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
        setShowLockedProductsAnimation(true);
        setTimeout(() => {
          setShowLockedProductsAnimation(false);
        }, 1000);
        if (!isDesktopUser()) {
          setTimeout(() => {
            setShowAnimation(false);
            setShowHeader('-56px'); // for Mweb
            setShowTop(true);
          }, 1000);
        }
      } else {
        if (setShowAnimation) {
          document.getElementById(`twoGrid`)?.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
          });
          setShowAnimation(true);
          if (!isDesktopUser()) {
            setTimeout(() => {
              setShowAnimation(false);
              setShowHeader('-56px'); // for Mweb
              setShowTop(true);
            }, 1000);
          }
        }
      }
    } else {
      if (setShowAnimation) {
        document.getElementById(`twoGrid`)?.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
        });
        setShowAnimation(true);
        if (!isDesktopUser()) {
          setTimeout(() => {
            setShowAnimation(false);
            setShowHeader('-56px'); // for Mweb
            setShowTop(true);
          }, 1000);
        }
      }
    }
  };
  useEffect(() => {
    fireEvent({
      category: 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: text,
      shape: 'cta',
      page_url: window.location.href.slice(0, 99),
      cta: text,
    });
  }, []);
  return (
    <SelectFavDiaper>
      <button
        ref={choosenRef}
        onClick={(event) => {
          createRippleEffectRelative(event, choosenRef.current);
          particularElementHandler();
        }}
      >
        {text}
      </button>
    </SelectFavDiaper>
  );
}
